import type { ForwardedRef, ReactNode } from 'react';
import { forwardRef } from 'react';

type ButtonProps = {
  className?: string;
  children?: ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  processing?: boolean;
};

export const Button = forwardRef(function Button(
  { className = '', children, onClick, disabled = false, processing = false }: ButtonProps,
  ref: ForwardedRef<HTMLButtonElement>,
) {
  function handleClick() {
    if (disabled) return;
    if (processing) return;
    onClick?.();
  }

  return (
    <button
      ref={ref}
      className={`outline-none appearance-none inline-flex rounded border border-solid border-black c-button ${className}`}
      onClick={handleClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
});
